import './index.less';
import SectionTabs from '@/components/Home/HomepageV2/Tabs';
import TabSection from '@/components/Home/HomepageV2/TabSection';
import BrandGrid from '@/components/Home/HomepageV2/BrandGrid';
import SupplierProfileSection from '@/components/Home/HomepageV2/SupplierProfileSection';
import StartNow from '@/components/Home/HomepageV2/StartNow';
import React, { useRef, useState } from 'react';
import HomePageIntro from '@/components/Home/HomepageV4/Intro';
import FAQContainer from '@/components/Common/FAQContainer';
import Script from 'next/script';
import { HOMEPAGE_TAB_SECTIONS, SECTION_TABS } from '@/shared/constants/homepage-constants';
import { map } from 'lodash-es';
import { HomepagePlatformSection, SectionTabType } from '@/shared/types/homepage';
import { SEO_HOMEPAGE } from '@/shared/constants/seo';
import { faqJsonLd } from '@/shared/seo/jsonld';

const HomepageV4 = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [selectedAnchor, setSelectedAnchor] = useState<string>(SECTION_TABS[0].anchor);

  const handleClickTab = (tab: SectionTabType) => {
    setSelectedAnchor(tab.anchor);
  };

  return (
    <div className="pietra-home-page-v3">
      <HomePageIntro />
      <div className="pietra-home-page-v3-content">
        <div className="text-section-wrap">
          <div className="text-section-content">
            <div className="title">Pietra makes it easy to scale your operations & marketing.</div>
            <div className="description">
              Pietra provides services like sourcing, fulfillment, & quality control services for those just starting
              out, and AI powered marketing and operations software for brands looking to scale.
            </div>
          </div>
        </div>
        <SectionTabs tabs={SECTION_TABS} handleClickTab={handleClickTab} />
        <div className="homepage-tab-sections">
          {map(
            HOMEPAGE_TAB_SECTIONS.filter((section: HomepagePlatformSection) => section.anchor === selectedAnchor),
            (section: HomepagePlatformSection) => {
              return <TabSection key={section.id} section={section} />;
            },
          )}
        </div>
        <div ref={ref} className="homepage-bottom-content">
          <BrandGrid />
          <SupplierProfileSection />
          <FAQContainer faq={SEO_HOMEPAGE} />
          <Script
            id="faq-seo-homepage"
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(faqJsonLd(SEO_HOMEPAGE)),
            }}
          />
          <StartNow />
        </div>
      </div>
    </div>
  );
};

export default HomepageV4;
